var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50015 5.875V9.125M7.20085 6.6875L9.79893 8.3125M9.79878 6.6875L7.2007 8.3125M4.54949 5.875V9.125M3.25017 6.6875L5.84826 8.3125M5.84807 6.6875L3.25 8.3125M12.4511 5.875V9.125M11.1517 6.6875L13.7498 8.3125M13.7496 6.6875L11.1516 8.3125M1 7.5C1 4.43587 1 2.90381 1.87868 1.9519C2.75736 1 4.17157 1 7 1H10C12.8284 1 14.2427 1 15.1213 1.9519C16 2.90381 16 4.43587 16 7.5C16 10.5641 16 12.0962 15.1213 13.0481C14.2427 14 12.8284 14 10 14H7C4.17157 14 2.75736 14 1.87868 13.0481C1 12.0962 1 10.5641 1 7.5Z",
    stroke: "#99AEA2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.4580e03adc5560c1ba0cc5609733514c.svg";
export { ForwardRef as ReactComponent };